
import { motion } from 'framer-motion';

export default function ContactSection() {
  return (
    <section id="contato" className="py-16 lg:py-32 bg-[#1B4D3E] relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'repeating-linear-gradient(45deg, #C5A059 0, #C5A059 2px, transparent 2px, transparent 60px)',
      }} />

      <div className="relative max-w-[1400px] mx-auto px-5 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-10 lg:mb-16"
        >
          <span className="font-montserrat text-[#C5A059] text-sm uppercase tracking-[3px]">Entre em Contato</span>
          <h2 className="font-cinzel font-semibold text-white text-3xl lg:text-5xl mt-4 mb-4 lg:mb-6">
            Transforme Seu Projeto em Realidade
          </h2>
          <p className="font-montserrat text-white/80 text-base lg:text-lg max-w-[600px] mx-auto">
            Nossa equipe está pronta para atender arquitetos e condomínios de alto padrão
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-[30px] lg:gap-12 max-w-[900px] mx-auto">
          <motion.a
            href="https://wa.me/5518996901341"
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.6 }}
            className="group bg-white/10 backdrop-blur-sm rounded-2xl p-6 lg:p-10 hover:bg-white/15 transition-all cursor-pointer"
          >
            <div className="w-14 h-14 lg:w-16 lg:h-16 rounded-full bg-[#C5A059] flex items-center justify-center mb-4 lg:mb-6 group-hover:scale-110 transition-transform">
              <i className="ri-whatsapp-line text-white text-2xl lg:text-3xl"></i>
            </div>
            <h3 className="font-montserrat font-semibold text-white text-xl lg:text-2xl mb-2 lg:mb-3">WhatsApp</h3>
            <p className="font-montserrat text-white/70 text-sm lg:text-base mb-4">
              Atendimento rápido e personalizado para seu projeto
            </p>
            <div className="flex items-center gap-2 text-[#C5A059] font-montserrat font-semibold text-sm uppercase group-hover:gap-4 transition-all">
              Iniciar Conversa
              <i className="ri-arrow-right-line"></i>
            </div>
          </motion.a>

          <motion.a
            href="https://instagram.com/vittaprimegrass"
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4, duration: 0.6 }}
            className="group bg-white/10 backdrop-blur-sm rounded-2xl p-6 lg:p-10 hover:bg-white/15 transition-all cursor-pointer"
          >
            <div className="w-14 h-14 lg:w-16 lg:h-16 rounded-full bg-[#C5A059] flex items-center justify-center mb-4 lg:mb-6 group-hover:scale-110 transition-transform">
              <i className="ri-instagram-line text-white text-2xl lg:text-3xl"></i>
            </div>
            <h3 className="font-montserrat font-semibold text-white text-xl lg:text-2xl mb-2 lg:mb-3">Instagram</h3>
            <p className="font-montserrat text-white/70 text-sm lg:text-base mb-4">
              Acompanhe nossos projetos e inspirações
            </p>
            <div className="flex items-center gap-2 text-[#C5A059] font-montserrat font-semibold text-sm uppercase group-hover:gap-4 transition-all">
              Seguir Perfil
              <i className="ri-arrow-right-line"></i>
            </div>
          </motion.a>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6, duration: 0.6 }}
          className="mt-10 lg:mt-16 text-center"
        >
          <div className="inline-flex flex-col gap-4 bg-white/5 backdrop-blur-sm rounded-2xl p-6 lg:p-8">
            <div className="flex items-center gap-3 text-white/80">
              <i className="ri-mail-line text-[#C5A059] text-xl"></i>
              <span className="font-montserrat text-sm lg:text-base">contato@vittaprimegrass.com.br</span>
            </div>
            <div className="flex items-center gap-3 text-white/80">
              <i className="ri-phone-line text-[#C5A059] text-xl"></i>
              <span className="font-montserrat text-sm lg:text-base">(18) 99690-1341</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
